import { createGlobalStyle } from 'styled-components';
import form from './form';
import generic from './generic';

export default createGlobalStyle`
  ${generic}
  ${form}
`;
